import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getPharmDashboardService } from '../../../domains/pharmDashboard';

const KEY = 'ad-campaigns';

// 실패 문구(result_msg)는 화면에 그대로 보여 준다 (백엔드 10/22 안내)
const unwrap = (res: any) => {
  if (res?.result_code !== '200' && res?.resultCode !== 200) throw new Error(res?.result_msg || '요청에 실패했습니다.');
  return res.data;
};

/** GET /pharm-dashboard/ad-campaigns → { count, joined_count, items[] } (brn 은 로그인 게이트) */
export const useAdCampaigns = (brn: string | null | undefined) =>
  useQuery({
    queryKey: [KEY, brn],
    enabled: !!brn,
    queryFn: async () => unwrap(await getPharmDashboardService().getAdCampaigns()),
  });

/** 참여 / 참여 취소 → 목록 다시 조회 */
export const useAdCampaignJoin = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, join }: { id: number; join: boolean }) =>
      unwrap(await getPharmDashboardService().setAdCampaignJoin(id, join)),
    onSettled: () => qc.invalidateQueries({ queryKey: [KEY] }),
  });
};
